module.exports = __webpack_public_path__ + "assets/5bc849b279afd13601b171f9e7efc339.png";